import { render, staticRenderFns } from "./billDetails.vue?vue&type=template&id=01684b1a&scoped=true"
import script from "./billDetails.vue?vue&type=script&lang=js"
export * from "./billDetails.vue?vue&type=script&lang=js"
import style0 from "./billDetails.vue?vue&type=style&index=0&id=01684b1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01684b1a",
  null
  
)

export default component.exports